import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
  dividerClasses,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import { FormButton } from "../../atoms";

export type ConfirmActionType = {
  message?: string;
  title?: string;
  buttonText?: string;
  onClose?: () => void;
  onConfirm?: () => void;
};
export type ConfirmStateProps = {
  open: boolean;
} & ConfirmActionType;

type ConfirmModalProps = {
  handleState: (params: any) => void;
} & ConfirmStateProps;
export const ConfirmModal = ({
  buttonText = "Confirm",
  message = "Are you sure you want to do this?",
  open = false,
  onClose = () => {},
  onConfirm = () => {},
  handleState = () => {},
  title,
}: ConfirmModalProps) => {
  const handleClose = () => {
    onClose();
    handleState({ open: false });
  };
  const handleConfirm = () => {
    onConfirm();
    handleState({ open: false });
  };
  return (
    <Dialog
      open={open}
      maxWidth={"xs"}
      onClose={handleClose}
      sx={{
        "div.MuiPaper-root.MuiDialog-paper": {
          paddingX: "60px",
        },
      }}
    >
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: "1.5625rem",
          top: "0.9375rem",
          zIndex: 100000,
        }}
      >
        <CloseIcon sx={{}} />
      </IconButton>
      <DialogContent sx={{ position: "relative" }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: "center" }}>
          <ErrorIcon color="error" sx={{ width: "5rem", height: "5rem" }} />
          {title && (
            <div
              style={{ fontSize: "30px", fontWeight: 700, lineHeight: "130%" }}
            >
              {title}
            </div>
          )}
          {message && (
            <div
              style={{ fontSize: "18px", fontWeight: 500, lineHeight: "22px" }}
            >
              {message}
            </div>
          )}
          <Box
            sx={{
              gap: "0.625rem",
              display: "grid",
              // paddingY: "1rem",
              width: "100%",
              button: {
                paddingY: "0.8rem",
                fontSize: "14px",
                fontWeight: 500,
                borderRadius: "18px",
              },
            }}
          >
            <Button color="secondary" fullWidth onClick={handleConfirm}>
              {buttonText}
            </Button>
            <Button
              fullWidth
              onClick={handleClose}
              variant="text"
              sx={{ color: "#ffffff" }}
            >
              Cancel
            </Button>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
